import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { UserApi } from "../api-services/user.api";
import { useNavigate } from "react-router";

export function AccountValidation()
{
    const user = UserApi();
    const [ code, setCode ] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleForm = async ( event ) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const res = await user.activateAccount({ code : code });
            if (res.data.success) {
              setStatus(1);
              navigate('/');
            }
            else{
              setStatus(-1);
            }
            setIsLoading(false);
        } catch (err) { 
            setStatus(-1); 
            setIsLoading(false);
        } 
    } 
    

    return (

      <div className="vh-100 d-flex flex-column justify-content-between">
        <div className="container-fluid py-4 bg-green-light border-bottom"></div>
        <div className="container py-5">
          <div className="row d-flex flex-column align-items-center justify-content-center py-5 px-2">
            <div className="col-lg-6 rounded-4 border p-5 mb-5 shadow-sm">

              <form onSubmit={ handleForm } className="d-flex flex-column">
                <div className=" d-flex flex-column gap-2 mb-4" > 
                  <img src="./favicon.png" alt="icon-agrospace" width="60" className=""/>
                  <span className="fs-4 text-muted text-start"> Agrospace - Validation compte </span>
                  <span className="text-muted text-start">
                    Merci de votre inscription ! Un code de validation vous a été envoyé par SMS. Saisissez-le ci-dessous pour activer votre compte et accéder à l’ensemble des services Agrospace.
                  </span>
                </div>
                {
                  isLoading && (
                    <div className="d-flex justify-content-center align-items-center mb-3"> 
                      <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }

                {
                  status === 1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-success">
                          Votre compte est créé avec succes. Veuillez vous connecter.
                      </div>
                    </div>
                  )
                }

                {
                  status === -1 && (
                    <div className="col-md-12 mb-2">
                      <div className="alert alert-danger">
                        Erreur! veillez revérifier le code reçu puis rééssayer.
                      </div>
                    </div>
                  )
                }
                {/* -------------------------------- */}
                <div className="col-md-12 mb-2"> 
                  <div className="d-flex gap-2 mb-2" >
                    <input type="number" name="code" placeholder="Code" className="w-100 border input py-3 px-3 text-muted rounded-2"  required onChange={ e => setCode(e.target.value)  }/>
                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                  </div>
                </div>
                {/* -------------------------------- */}
                <div>
                  <button type="submit" className="btn btn-lg btn-success px-4 mt-2"> 
                    Soumettre <i className="bi bi-arrow-right"></i> 
                  </button> 
                </div>    
              </form>
                
            </div>
            {
                status === 1 && (
                    <div className="col-md-6 d-flex justify-content-center p-4 mt-3 bg-white shadow-sm rounded-3 border">
                      <a className="btn btn-sm btn-outline-dark d-flex align-items-center px-4" href="/">
                        Retour à la page d'accueil <i className="bi bi-arrow-right ms-2"></i>
                      </a>
                    </div>
                )
            }
            
          </div>
        </div>
       
        <div className="container-fluid p-4 bg-green-light">
          {/* Bottom Section */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3 border-top">
            <p className="mb-2 mb-md-0"> © 2025 Agrospace pack. Tout droit réservé. </p>
            <div className="d-flex flex-wrap gap-3">
              <p className="mb-2 mb-md-0"> powered by Xelkoom-AI </p>
            </div>
          </div>
          {/* Social Icons */}
          <div className="d-flex justify-content-center gap-3 my-3">
              <i className="bi bi-facebook fs-5"></i>
              <i className="bi bi-twitter-x fs-5"></i>
              <i className="bi bi-linkedin fs-5"></i>
              <i className="bi bi-github fs-5"></i>
              <i className="bi bi-instagram fs-5"></i>
              <i className="bi bi-youtube fs-5"></i>
          </div>
        </div>

      </div>
    )
}